import createSelector from "../../utils/reselect";

const portfolioStateData = (state) => {
  const { portfolios } = state;
  return portfolios || {};
};

export const loading = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolioLoading")
);

export const overviewLoader = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("overviewLoader")
);

export const getError = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("error")
);

export const portfolio = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolio")
);

//GET PORTFOLIO
export const portfolios = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolios")
);

export const portfoliosLoading = createSelector(
  portfolioStateData,
  (portfolios) => portfolios.get("portfoliosLoading")
);

export const portfolioBudgetSummary = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolioBudgetSummary")
);
export const portfolioProgressSummary = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolioProgressSummary")
);
export const portfolioBudgetSummaryLoading = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolioBudgetSummaryLoading")
);
export const portfolioProgressSummaryLoading = createSelector(portfolioStateData, (portfolios) =>
  portfolios.get("portfolioProgressSummaryLoading")
);

//PORTFOLIO PAGINATION

export const portfolioPagination = createSelector(
  portfolioStateData,
  (portfolios) => portfolios.get("portfolioPagination")
);
